import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-alertloops',
  templateUrl: './alertloops.component.html',
  styleUrls: ['./alertloops.component.scss']
})
export class AlertloopsComponent implements OnInit {

  alertloop: any;
  alertloops: any;
  id?: number;
  view: any = "full";
  sort = 'name';

  formGroup = new FormGroup ({
    search: new FormControl('',[])
  });

  nameFormGroup = new FormGroup({
    name: new FormControl('',[Validators.required])
  });

  submitted = false;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  get f(): { [key: string]: AbstractControl } {
    return this.nameFormGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.view = localStorage.getItem("alertloop_view") ? localStorage.getItem("alertloop_view") : this.view;

    this.getAlertLoops();

  }

  getAlertLoops(){

    let filter = {
      sort: this.sort,
      search: this.formGroup.value.search,
      page: this.pagination.page,
    }

    //console.log('filter', filter);

    this.okService.get("alertloops",filter)
    .subscribe((data) => {

      this.alertloops = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

      console.log("getAlertLoops", data);
      console.log("okService",this.okService.settings);
      // this.setupLoopLimit();

    });

  }

  submitForm(){
    //console.log("submitForm()");

    if(this.submitted){
      Object.keys(this.nameFormGroup.controls).forEach(key => {
        this.nameFormGroup.get(key)?.setErrors({ invalid: null });
        this.nameFormGroup.get(key)?.updateValueAndValidity();
      });
    }

    this.submitted = true;

    if (this.nameFormGroup.valid) {
      let values = this.nameFormGroup.value

      this.okService.post("alertloops",values)
      .subscribe({
          next: (data) => {
            this.alertloop = data.body;

            //console.log("nameFormGroup submit", this.alertloop);

            let id = this.alertloop.id

            this.router.navigateByUrl("/mgmt/alertloop/"+id);

          },
          error: (e) => {

            if(Array.isArray(e)){
              let self = this;
              // Use of _.forEach() method
              _.forEach(e, function(error:any) {
                //console.log(error);
                self.nameFormGroup.get(error.field)?.setErrors({ invalid: error.message });
              });
            }else{
              this.okService.setAlert(e,"warning")
            }


          },
          complete: () => {
            //console.info('complete');
          }
      });
    }

  }

  changePage(){
    this.getAlertLoops();
  }

  updateFilter(){
    if(this.formGroup.valid){
      this.getAlertLoops();
    }
  }

  cancelSearch(){
    this.formGroup.setValue({
      search: ''
    });
    this.updateFilter();

  }

  toggleEnabled(){

    let alertloop = !this.okService.settings.alertloop;

    this.okService.put('account',{'alertloop':alertloop})
    .subscribe((data) => {
      //console.log("toggle w3w",data)
      }
    );
  }

  changeView(view:any){
    this.view = view;

    localStorage.setItem("alertloop_view",view)
  }
  
  export(){
    this.okService.download("alertloops/export");
  }

}

